import { useCallback } from 'react';

import { mealImageToDisplay } from 'helpers/mealDisplay';
import {
  EXPRESSPLUS_SATURATION_DYNAMIC,
  EXPRESSPLUS_SATURATION_STATIC,
  PREMIUM_SIDE_ANGLE_STATIC,
  PREMIUM_SIDE_ANGLE_DYNAMIC,
  HNE_TRAY_IMAGE,
} from 'lib/constants';

import useFetchExperimentAssignment from './useFetchExperimentAssignment';

const useMealImageResolver = () => {
  const { isVariant: isInExpressPlusSaturationDynamicExperiment } = useFetchExperimentAssignment(
    EXPRESSPLUS_SATURATION_DYNAMIC
  );
  const { isVariant: isInExpressPlusSaturationStaticExperiment } = useFetchExperimentAssignment(
    EXPRESSPLUS_SATURATION_STATIC
  );

  const { isVariant: isInPremiumSideAngleStaticExperiment } =
    useFetchExperimentAssignment(PREMIUM_SIDE_ANGLE_STATIC);
  const { isVariant: isInPremiumSideAngleDynamicExperiment } = useFetchExperimentAssignment(
    PREMIUM_SIDE_ANGLE_DYNAMIC
  );

  const { isVariant: isInHneTrayImageExperiment } = useFetchExperimentAssignment(HNE_TRAY_IMAGE);

  const isInExpressPlusSaturationExperimentVariant =
    isInExpressPlusSaturationDynamicExperiment || isInExpressPlusSaturationStaticExperiment;

  const isInPremiumSideAngleExperimentVariant =
    isInPremiumSideAngleStaticExperiment || isInPremiumSideAngleDynamicExperiment;

  return useCallback(
    meal =>
      mealImageToDisplay(
        meal,
        isInExpressPlusSaturationExperimentVariant,
        isInPremiumSideAngleExperimentVariant,
        isInHneTrayImageExperiment
      ),
    [
      isInExpressPlusSaturationExperimentVariant,
      isInPremiumSideAngleExperimentVariant,
      isInHneTrayImageExperiment,
    ]
  );
};

export default useMealImageResolver;
